import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetOrderRequest } from "client/utils/RequisitionUtil";
import CreateOrder from "./CreateOrder";
import ConfirmationBee from "../../../assets/images/ConfirmationBee.svg";
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import selectors from "redux/Navigation/selectors";
import { operations as navigationOperations } from "redux/Navigation";
import navOperations from "redux/Navigation/operations";
import TransferAction from "Store/Component/Transfer/TransferAction";

const CreateOrderContainer = () => {

  // Dispatch
  const dispatch = useDispatch();
  const navDispatch = navigationOperations.dispatchNav(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);

  // Declarations
  const [isRequestDeleted, setIsRequestDeleted] = useState<any>(false);
  const [isReasonDeleted, setIsReasonDeleted] = useState<any>(false);
  const [isDealerChangesOccured, setIsDealerChangesOccured] = useState<any>(false);
  const [itemDetailComponent, setItemDetailComponent] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [showCartClicked, setShowCartClicked] = useState(false)
  const [showCreateRequisition, setShowCreateRequisition] = useState(true)
  const [successAlert, setSuccessAlert] = useState(false);
  const [showCatalog, setShowCatalog] = useState(false);
  const [confirmBtnClick, setConfirmBtnClick] = useState<any>(false);
  const navigate = useNavigate();
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });
  /// Selectors
  const { orderId, reasonCartList, isChangesOccured, headerNav, isUpdateSuccessAlert, isAddToCartClick }: any = useSelector((state?: any) => ({
    orderId: state.RequisitionReducer.orderId,
    reasonCartList: state.RequisitionReducer.reasonCartList,
    isChangesOccured: state.RequisitionReducer.isChangesOccured,
    headerNav: selectors.GetHeaderNav(state),
    isUpdateSuccessAlert: state.RequisitionReducer.isUpdateSuccessAlert,
    isAddToCartClick: state.RequisitionReducer.isAddToCartClick,
  }));

  useEffect(() => {
    if (orderId !== undefined && orderId !== 0) {
      setItemDetailComponent(true);
      if (mobile) {
        setShowCartClicked(false);
        setShowCart(true);
      } else {
        setShowCartClicked(true);
        setShowCart(true);
      }
    }
  }, [orderId, mobile]);

  useEffect(() => {
    if(isAddToCartClick){
      setSuccessAlert(true)
      setShowCart(true)
    }
    else{
      setSuccessAlert(isUpdateSuccessAlert)
    }
  }, [isUpdateSuccessAlert]);

    //disabling the cart when clicking the new draft
    useEffect(() => {
      dismissSuccessAlert()
    },[orderId])


  useEffect(() => {
    
  }, [itemDetailComponent]);

  useEffect(() => {
    const resizeFun = () => {
      if (window.innerWidth < 600) {    
        setMobile(true)
        if(showCartClicked){
          setShowCart(true)
          setShowCreateRequisition(false)         
        }
        else {
          setShowCart(false)
          setShowCreateRequisition(true)
        }
      }
      else {
        setMobile(false);
        if(showCartClicked){
          setShowCart(true)
          setShowCreateRequisition(true)
        }
        else {
          setShowCart(false)
          setShowCreateRequisition(true)
        }
        setShowCreateRequisition(true)
        //setShowCart(true)
      }
    }
    resizeFun();

    window.addEventListener('resize', resizeFun)

    return () => window.removeEventListener('resize',resizeFun)
  },[showCartClicked,orderId]);


  useEffect(() => {
    setTimeout(() => {
      setSuccessAlert(false)
      dispatch(RequisitionAction.setIsUpdateSuccessAlert(false))
    }, 30000)
  }, [showCart, successAlert])

  useEffect(() => {
    if(mobile){
      if(showCartClicked){
        if (reasonCartList?.length === 0 && showCart) {
          setShowCart(false);
          setShowCreateRequisition(true)
        } else {
          setShowCart(true);
          setShowCreateRequisition(false)
        }
      }
      else {
        setShowCart(false);
        setShowCreateRequisition(true)
      }     
    }
    else {
      // console.log(reasonCartList?.length,'length')
      if (reasonCartList?.length === 0 && showCart) {
        setShowCart(false);
      } else if (reasonCartList?.length > 0) {
        setShowCart(true);
      }
    }
  }, [reasonCartList]);

  const dismissSuccessAlert = () => {
    dispatch(RequisitionAction.setIsUpdateSuccessAlert(false))
    setSuccessAlert(false)
  }
  const activeMenu = useSelector((state:any) => state.nav.nav);
  
  const {orderEditNavigateChange}: any = useSelector((state?: any) => ({    orderEditNavigateChange:state.RequisitionReducer.orderEditNavigateChange  }))
  const breadcrumbtitle= headerNav == "Home" ? "Home" : activeMenu === "Customer My Orders" ? "Requests" : activeMenu === "MyOrderDetail" && orderEditNavigateChange === "Customer My Orders" ? "Requests" : headerNav;
  const breadcrumlist = [
    {
      text: breadcrumbtitle,
      key: "f1",
      href: "/ordermanagement",
      onClick: (e: any) => {
        e.preventDefault();
        if(isChangesOccured && !confirmBtnClick){
          let decriptionTxt = (
            <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
          );
          setPopupcontent({
            ...Popupcontent,
            titleImg: ConfirmationBee,
            title: "UNSAVED CHANGES",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "No",
            primaryBtnText: "Yes",
            popupConfirmationOutlinebtnOnclick: popupConfirmationOutlinebtnOnclick,
            popupConfirmationPrimarybtnOnclick: popupConfirmationPrimarybtnOnclick,
            isSingleConfirmationBtn: false,
          });
        }else{
          if(headerNav == "ActiveAsset"){
            navigate('/ordermanagement/ActiveAsset')
          }else{
            navigate('/ordermanagement');
          }
        navDispatch(headerNav);
        dispatchHeaderNav(headerNav);
        }
      },
    },
    { text: "Create New Requisition", key: "f2" },
  ];

  const popupConfirmationOutlinebtnOnclick = () => {
    hideDialog()
  }

  const popupConfirmationPrimarybtnOnclick = () => {
    setConfirmBtnClick(true);
    dispatch(RequisitionAction.setIsChangesOccured(false))
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
  }

  useEffect(() => {
    if (!isChangesOccured && confirmBtnClick) {
      hideDialog()
      handleClickBack()
    }
  }, [isChangesOccured, confirmBtnClick])

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  };
  
  const handleClickBack = () => {
    if (showCart) {
      if (mobile) {
        setShowCart(false);
        setShowCreateRequisition(true)
        setShowCartClicked(false)
      }
      else {
        if(isChangesOccured && !confirmBtnClick){
          let decriptionTxt = (
            <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
          );
          setPopupcontent({
            ...Popupcontent,
            titleImg: ConfirmationBee,
            title: "UNSAVED CHANGES",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "No",
            primaryBtnText: "Yes",
            popupConfirmationOutlinebtnOnclick: popupConfirmationOutlinebtnOnclick,
            popupConfirmationPrimarybtnOnclick: popupConfirmationPrimarybtnOnclick,
            isSingleConfirmationBtn: false,
          });
        }else{
        resetOrderRequest(dispatch);
        if(headerNav == "ActiveAsset"){
          navigate('/ordermanagement/ActiveAsset')
        }else{
          navigate('/ordermanagement')
        }
        navDispatch(headerNav);
        dispatchHeaderNav(headerNav);
        }
      }
    }
    else {
      if(isChangesOccured && !confirmBtnClick){
        let decriptionTxt = (
          <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
        );
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: "UNSAVED CHANGES",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          outlineBtnText: "No",
          primaryBtnText: "Yes",
          popupConfirmationOutlinebtnOnclick: popupConfirmationOutlinebtnOnclick,
          popupConfirmationPrimarybtnOnclick: popupConfirmationPrimarybtnOnclick,
          isSingleConfirmationBtn: false,
        });
      }else{
      resetOrderRequest(dispatch);
      navigate('/ordermanagement')
      }
    }
  }

  const mycartButton = () => {
    setShowCartClicked(true)
    setShowCart(true);
    setShowCreateRequisition(false)
    setSuccessAlert (false)
  }

  const activeNavigation = useSelector((state:any) => state.nav.nav)
  useEffect(() => {
     document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
  }, [activeNavigation]);
 
  return (
    <CreateOrder
      breadcrumlist={breadcrumlist}
      navigate={navigate}
      handleClickBack={handleClickBack}
      itemDetailComponent={itemDetailComponent}
      mobile={mobile}
      mycartButton={mycartButton}
      showCart={showCart}
      setShowCart={setShowCart}
      reasonCartList={reasonCartList}
      //  handleClickAddCart={handleClickAddCart}
      dismissSuccessAlert={dismissSuccessAlert}
      successAlert={successAlert}
      setItemDetailComponent={setItemDetailComponent}
      showCreateRequisition={showCreateRequisition}
      setShowCreateRequisition={setShowCreateRequisition}
      setSuccessAlert={setSuccessAlert}
      setShowCartClicked={setShowCartClicked}
      showCartClicked={showCartClicked}
      showCatalog={showCatalog}
      setShowCatalog={setShowCatalog}
      Popupcontent = {Popupcontent}
      hideDialog = {hideDialog}
      isUpdateSuccessAlert = {isUpdateSuccessAlert}
      setIsRequestDeleted = {setIsRequestDeleted}
      isRequestDeleted = {isRequestDeleted}
      setIsReasonDeleted = {setIsReasonDeleted}
      isReasonDeleted = {isReasonDeleted}
      setIsDealerChangesOccured = {setIsDealerChangesOccured}
      isDealerChangesOccured = {isDealerChangesOccured}
    />
  )
}


export default CreateOrderContainer;
